import React from 'react'
import styles from './MainTopHeader.module.scss'
import accountStyles from '../../IconActions/User/Account.module.scss'
import Back from 'svg/caret-left.svg'
import UserIcon from 'svg/user.svg'
import classNames from 'classnames'
import { capitalizeString } from 'lib/helpers'
import { useHeaderContext } from '../../HeaderContext'
import { useSelector } from 'react-redux'
import { getFullName, getUserInitials, isAuthenticated } from 'selectors/user/session'

const MainTopHeader = () => {
  const fullName = useSelector(getFullName)
  const userInitials = useSelector(getUserInitials)
  const authenticated = useSelector(isAuthenticated)
  const { setSelectedCategory, setMobileHeaderConfig } = useHeaderContext()

  const backToCategoriesMenu = () => {
    setMobileHeaderConfig((previousMobileHeaderConfig) => ({
      ...previousMobileHeaderConfig,
      mobileMenuContent: 'categories',
      mobileTopHeader: 'mainTopHeader',
    }))
    setSelectedCategory(null)
  }

  const fullNameTruncated =
    fullName && fullName?.length > 35 ? fullName?.slice(0, 35).concat('...') : fullName
  const capitalizedFullName = capitalizeString(fullNameTruncated)

  return (
    <>
      <div className={styles.topHeaderMenuAccount}>
        <div onClick={backToCategoriesMenu}>
          <Back className={styles.closeIcon} />
        </div>
        <div className={styles.user}>
          {authenticated ? (
            <span className={accountStyles.accountIconInitials}>{userInitials}</span>
          ) : (
            <UserIcon className={styles.userIcon} />
          )}
          <p className={classNames('defaultTypographyH5', styles.userName)}>
            {capitalizedFullName ? capitalizedFullName : 'Log In / Register'}
          </p>
        </div>
      </div>
    </>
  )
}

export default MainTopHeader
